import { render, staticRenderFns } from "./font-weight.vue?vue&type=template&id=87624f88&"
import script from "./font-weight.vue?vue&type=script&lang=js&"
export * from "./font-weight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports